/* cc-wishlist.js — Cologne Curators wishlist (Phase 1, localStorage)
   Heart toggle on cards/PDP, a header heart + count (injected, no Expanse header
   edit), and the /pages/wishlist render. Guests + logged-in both use localStorage;
   cross-device (customer metafield) is Phase 2. No dependencies. Loaded globally. */
(function () {
  var KEY = 'cc_wishlist';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} broadcast(); }
  function has(h) { return get().some(function (x) { return x.h === h; }); }
  function toggle(meta) {
    var a = get(), i = -1;
    for (var k = 0; k < a.length; k++) if (a[k].h === meta.h) { i = k; break; }
    if (i >= 0) a.splice(i, 1); else a.unshift({ h: meta.h, id: meta.id, n: meta.n });
    save(a); return i < 0; // true = now saved
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* ---- reflect state into every heart + the header count ---- */
  function broadcast() {
    var saved = get(), set = {};
    saved.forEach(function (x) { set[x.h] = 1; });
    [].forEach.call(document.querySelectorAll('[data-wishlist]'), function (b) {
      var on = !!set[b.getAttribute('data-wishlist')];
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      // keep icon-only hearts' accessible name in step with saved state
      var nm = b.getAttribute('data-wishlist-name');
      if (nm && b.hasAttribute('aria-label')) b.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + nm + (on ? ' from wishlist' : ' to wishlist'));
    });
    var c = document.querySelector('[data-wishlist-count]');
    if (c) { c.textContent = saved.length; c.hidden = saved.length === 0; }
    var page = document.querySelector('[data-cc-wishlist-page]');
    if (page) renderPage(page);
  }

  /* ---- header heart FALLBACK ----
     The heart is now SERVER-rendered in header.icons.liquid (no CLS). This inject
     path only fires if that markup is absent (guard below early-returns otherwise). */
  function injectHeader() {
    if (document.querySelector('[data-wishlist-count]')) return;
    var icons = document.querySelector('.header-item--icons .site-nav__icons, .header-item--icons, .site-header__icons');
    if (!icons) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'cc-wishlist-headerlink';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = heartSvg() + '<span class="cc-wishlist-headerlink__count" data-wishlist-count hidden>0</span>';
    // place before the cart if we can, else append
    var cart = icons.querySelector('[class*="cart"], [href*="/cart"]');
    if (cart && cart.parentNode === icons) icons.insertBefore(a, cart); else icons.appendChild(a);
  }
  function heartSvg() {
    return '<svg class="cc-wishlist-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
      '<path d="M12 20.5l-1.2-1.1C6.4 15.3 3.5 12.7 3.5 9.5 3.5 7 5.4 5 7.9 5c1.5 0 2.9.7 3.8 1.9l.3.4.3-.4C13.2 5.7 14.6 5 16.1 5 18.6 5 20.5 7 20.5 9.5c0 3.2-2.9 5.8-7.3 9.9L12 20.5z"/></svg>';
  }

  /* ---- wishlist page render (client-side, /products/{h}.js like the Finder) ---- */
  function renderPage(page) {
    var saved = get();
    if (!saved.length) {
      page.innerHTML = '<div class="cc-wishlist-empty"><p class="cc-wishlist-empty__msg">Your wishlist is empty.</p>' +
        '<a class="cc-btn cc-btn--primary" href="/collections/all">Browse fragrances</a></div>';
      return;
    }
    page.innerHTML = '<ul class="ccf-matches cc-wishlist-grid" data-wl-grid></ul>';
    var grid = page.querySelector('[data-wl-grid]');
    saved.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'ccf-card'; li.setAttribute('data-wl-card', item.h);
      li.innerHTML =
        '<a class="ccf-card__media" href="/products/' + esc(item.h) + '" tabindex="-1"><span class="ccf-card__ph" aria-hidden="true"></span></a>' +
        '<div class="ccf-card__body"><a class="ccf-card__name" href="/products/' + esc(item.h) + '">' + esc(item.n || item.h) + '</a>' +
        '<p class="ccf-card__price" data-wl-price></p>' +
        '<button type="button" class="cc-card__add" data-wishlist="' + esc(item.h) + '" data-wl-remove>Remove</button></div>';
      grid.appendChild(li);
      fetch('/products/' + item.h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]);
        if (img) { var ph = li.querySelector('.ccf-card__ph'); if (ph) { ph.style.backgroundImage = 'url("' + img + '")'; ph.classList.add('is-loaded'); } }
        var pr = li.querySelector('[data-wl-price]'); if (pr) pr.textContent = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      }).catch(function () {});
    });
  }

  /* ---- toast (Arun 2026-11-03): confirm every save/remove, mobile + desktop ---- */
  var toastTimer = null;
  function showToast(msg) {
    var t = document.getElementById('cc-wishlist-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'cc-wishlist-toast';
      t.className = 'cc-wishlist-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    // force reflow so re-triggering the class restarts the transition
    void t.offsetWidth;
    t.classList.add('is-on');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 1900);
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    // The heart may sit under / beside a full-tile PDP link; stop the tap from ALSO navigating.
    e.preventDefault();
    e.stopPropagation();
    var nowSaved = toggle({ h: b.getAttribute('data-wishlist'), id: b.getAttribute('data-wishlist-id'), n: b.getAttribute('data-wishlist-name') });
    var nm = b.getAttribute('data-wishlist-name');
    showToast(nowSaved ? ((nm ? nm + ' ' : '') + 'saved to your wishlist').replace(/^./, function (c) { return c.toUpperCase(); }) : 'Removed from your wishlist');
  });
  // cross-tab sync
  window.addEventListener('storage', function (e) { if (e.key === KEY) broadcast(); });

  function init() { injectHeader(); broadcast(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.ccWish = { has: has, list: get, count: function () { return get().length; } };
})();
